<div class='container'>
    <ng-container *ngIf='!!url'>
        <iframe (load)='onLoad()' [src]='url' class='iframe' title='iframe-call'></iframe>
        <button class="close" (click)='close()' mat-raised-button color='primary'>{{ "Close" | translate }}</button>
    </ng-container>
    <div *ngIf='showLoading' class='mask'>
        <i class='spinner'></i>
    </div>
</div>
